import { create } from 'zustand';

const useCreateUpdatePost = create((set) => ({
  isOpen: false,
  isUpdate: false,
  postData: null,
  docData: null,
  
  // Open for creating a new post
  openCreate: () => set({
    isOpen: true,
    isUpdate: false,
    data: null,
    docData: null
  }),
  
  // Open for updating an existing post
  openUpdate: (data, docData) => set({
    isOpen: true,
    isUpdate: true,
    postData: data,
    docData: docData
  }),
  
  // Close modal
  close: () => set({
    isOpen: false,
    isUpdate: false
  })
  
}));

export default useCreateUpdatePost;